<template>
	<div class="notification-r">
		<div>
			<div>
				<h1 class="text-left">Receipt Order# {{ ordercode }}</h1>
				<table>
					<tr>
						<th class="text-left">Product Name</th>
						<th class="text-left">Category</th>
						<th class="text-right">Quantity</th>
						<th class="text-right">Price</th>
					</tr>

					<tr v-for="order in orderinfo">
						<td class="text-left"><router-link :to="'/products/product/' + order.code" target="_blank">{{ order.product_name }}</router-link></td>
						<td class="text-left">{{ order.category }}</td>
						<td class="text-right">{{ order.quantity }}</td>
						<td class="text-right">Php {{ formatMoney(order.price) }}</td>
					</tr>
				</table>

				<div class="clearboth spacera"></div>

				<button class="button-type-h" style="float: right;" @click="exitReceipt">Done</button>

			</div>
		</div>
	</div>
</template>
<script>
	//NO current data
	export default{
		props: ['orderinfo', 'ordercode'],
		methods: {
			formatMoney: formatMoney,

			exitReceipt: function(event){
				this.$emit('exitReceipt');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// OrderReceipt.vue?0323e3b3